import AdminSidebar from "components/layout/AdminSidebar";
import Container from "components/layout/Container";
import Main from "components/layout/Main";

export default function PermissionDenied({
  unavailable = false,
}: {
  unavailable?: boolean;
}) {
  return (
    <Container>
      <AdminSidebar />
      <Main className="mx-5 mt-5 pb-10 text-left">
        <div className="flex min-h-[70vh] items-center justify-center">
          <div className="max-w-lg rounded-2xl border border-gray-200 bg-white px-8 py-12 text-center shadow-sm">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-orange-50 text-orange-700">
              <i className={`fa ${unavailable ? "fa-triangle-exclamation" : "fa-lock"}`} />
            </span>
            <h1 className="mt-5 text-xl font-semibold text-gray-950">
              {unavailable ? "Unable to verify access" : "Permission required"}
            </h1>
            <p className="mt-2 text-sm leading-6 text-gray-500">
              {unavailable
                ? "Your effective permissions could not be loaded. Refresh the page or sign in again. Access remains closed until verification succeeds."
                : "Your admin role does not grant access to this dashboard module. Contact a Super Admin if this access is required."}
            </p>
          </div>
        </div>
      </Main>
    </Container>
  );
}
